/**
 * Password-reset feature strings.
 *
 * Namespace: resetPassword
 */
export const resetPassword = {
  // Page
  page: {
    title: "Új jelszó megadása",
    subtitle: "Adja meg az új jelszavát",
  },

  // Form fields
  form: {
    passwordLabel: "Új jelszó",
    passwordPlaceholder: "••••••••",
    passwordHelperText: "Legalább 8 karakter",
    confirmPasswordLabel: "Jelszó megerősítése",
    confirmPasswordPlaceholder: "••••••••",
    submitButton: "Megerősítés",
    loadingButton: "Megerősítés...",
  },

  // Success
  success: {
    title: "Jelszó megváltoztatva!",
    message: "A jelszava sikeresen megváltozott. Most már bejelentkezhet az új jelszavával.",
    goToLogin: "Tovább a bejelentkezéshez",
  },

  // Errors
  errors: {
    invalidToken: "A jelszó-visszaállító link érvénytelen vagy lejárt.",
    expiredToken: "A jelszó-visszaállító link lejárt. Kérjen egy új linket.",
  },
} as const;

export type ResetPasswordMessages = typeof resetPassword;
